/*! FlowerHeart choice UI — storefront commercial flow (Bloem/Kleur/zoek/6 vazen/cart) */
(function (global) {
  'use strict'

  function formatMoney(cents) {
    if (cents == null || typeof cents !== 'number' || Number.isNaN(cents)) return ''
    var neg = cents < 0
    var n = Math.abs(cents)
    var euros = Math.floor(n / 100)
    var rest = String(n % 100).padStart(2, '0')
    return (neg ? '-' : '') + '€ ' + euros + ',' + rest
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
  }

  function mediaHtml(imageUrl, cls) {
    if (imageUrl) {
      return (
        '<img class="' +
        (cls || 'fh-choice__img') +
        '" src="' +
        esc(imageUrl) +
        '" alt="" loading="lazy" width="400" height="500">'
      )
    }
    return '<span class="' + (cls || 'fh-choice__ph') + '" aria-hidden="true"></span>'
  }

  function initChoiceFlow(root, config) {
    var flow = root.querySelector('[data-fh-choice-flow]')
    if (!flow) return

    var engine = null
    var dna = null
    var collectionProducts = []
    var availabilityIndex = {}
    var history = ['modes']
    var selected = {
      mode: null,
      speciesId: null,
      colorId: null,
      product: null,
      forceAsAnchor: false,
    }
    var enrichedBatch = []
    var activeDisplay = null
    var aiEnabled = false

    var statusEl = flow.querySelector('[data-fh-status]')
    var searchInputs = flow.querySelectorAll('[data-fh-search]')
    var anchorGrid = flow.querySelector('[data-fh-anchor-grid]')
    var speciesColorGrid = flow.querySelector('[data-fh-species-color-grid]')
    var colorGrid = flow.querySelector('[data-fh-color-grid]')
    var colorEmpty = flow.querySelector('[data-fh-color-empty]')
    var colorAnchorGrid = flow.querySelector('[data-fh-color-anchor-grid]')
    var flowerColorLead = flow.querySelector('[data-fh-flower-color-lead]')
    var colorAnchorLead = flow.querySelector('[data-fh-color-anchor-lead]')
    var proposalsEl = flow.querySelector('[data-fh-proposals]')
    var resultsTitle = flow.querySelector('[data-fh-results-title]')
    var resultsSub = flow.querySelector('[data-fh-results-sub]')
    var vaseEl = flow.querySelector('[data-fh-vase]')
    var vaseLines = flow.querySelector('[data-fh-vase-lines]')
    var vaseTotal = flow.querySelector('[data-fh-vase-total]')
    var vaseError = flow.querySelector('[data-fh-vase-error]')
    var cartSuccess = flow.querySelector('[data-fh-cart-success]')
    var aiBlock = flow.querySelector('[data-fh-ai]')
    var collectionNode = root.querySelector('[data-fh-collection-products]')

    function clearSearchUi() {
      searchInputs.forEach(function (input) {
        input.value = ''
      })
      flow.querySelectorAll('[data-fh-search-results]').forEach(function (el) {
        el.innerHTML = ''
        el.hidden = true
      })
    }

    function searchResultsEl(scope) {
      return flow.querySelector('[data-fh-search-results="' + scope + '"]')
    }
    function setStatus(msg, show) {
      if (!statusEl) return
      statusEl.hidden = !show
      statusEl.textContent = msg || ''
    }

    function labelOf(species) {
      return (species.labels && (species.labels.nl || species.labels.en)) || species.id
    }

    function colorLabel(colorId) {
      var colors = (dna.colors && dna.colors.colors) || []
      var c = colors.find(function (x) {
        return x.id === colorId
      })
      if (c && c.labels) return c.labels.nl || c.labels.en || colorId
      return colorId || ''
    }

    function showStep(name) {
      flow.querySelectorAll('[data-fh-step]').forEach(function (el) {
        el.hidden = el.getAttribute('data-fh-step') !== name
      })
    }

    function go(step) {
      history.push(step)
      showStep(step)
      setStatus('', false)
      if (step === 'results' || step === 'vase' || step === 'cart-success') {
        try {
          flow.scrollIntoView({ behavior: 'smooth', block: 'start' })
        } catch (e) {}
      }
    }

    function goBack() {
      if (history.length <= 1) {
        history = ['modes']
        selected = {
          mode: null,
          speciesId: null,
          colorId: null,
          product: null,
          forceAsAnchor: false,
        }
        clearSearchUi()
        showStep('modes')
        return
      }
      history.pop()
      var prev = history[history.length - 1]
      if (prev === 'modes') {
        selected = {
          mode: null,
          speciesId: null,
          colorId: null,
          product: null,
          forceAsAnchor: false,
        }
        clearSearchUi()
      }
      if (prev === 'color-list') {
        selected.speciesId = null
        selected.product = null
        // keep mode=color; clear color only when leaving color path entirely
        selected.colorId = null
        renderLiveColors()
      }
      if (prev === 'color-anchors' && selected.colorId) {
        selected.speciesId = null
        selected.product = null
        renderColorAnchors(selected.colorId)
      }
      if (prev === 'flower-anchors') {
        selected.colorId = null
        selected.product = null
        selected.speciesId = null
        renderFlowerAnchors()
      }
      showStep(prev)
      setStatus('', false)
    }

    function resetAll() {
      history = ['modes']
      selected = {
        mode: null,
        speciesId: null,
        colorId: null,
        product: null,
        forceAsAnchor: false,
      }
      enrichedBatch = []
      activeDisplay = null
      clearSearchUi()
      showStep('modes')
      setStatus('', false)
    }

    function cardButton(opts) {
      var li = document.createElement('li')
      li.className = 'fh-choice__cell'
      var btn = document.createElement('button')
      btn.type = 'button'
      var colorClass = opts.colorId
        ? ' fh-choice__card--color fh-choice__card--color-' + String(opts.colorId)
        : ''
      btn.className =
        'fh-choice__card' +
        (opts.large ? ' fh-choice__card--large' : '') +
        colorClass
      if (opts.colorId) {
        btn.setAttribute('data-fh-color', opts.colorId)
      }
      var media = ''
      if (opts.colorId) {
        media =
          '<span class="fh-choice__swatch" aria-hidden="true"></span>'
      } else {
        media = mediaHtml(opts.imageUrl)
      }
      btn.innerHTML =
        media +
        '<span class="fh-choice__card-title">' +
        esc(opts.title) +
        '</span>' +
        (opts.sub
          ? '<span class="fh-choice__card-sub">' + esc(opts.sub) + '</span>'
          : '') +
        (opts.meta
          ? '<span class="fh-choice__card-meta">' + esc(opts.meta) + '</span>'
          : '')
      btn.addEventListener('click', opts.onClick)
      li.appendChild(btn)
      return li
    }

    function renderFlowerAnchors() {
      var anchors = engine.getVisibleAnchors(dna, availabilityIndex)
      anchorGrid.innerHTML = ''
      if (!anchors.length) {
        var empty = document.createElement('li')
        empty.className = 'fh-choice__empty-cell'
        empty.innerHTML =
          '<div class="fh-choice__empty"><p class="fh-choice__empty-title">Nog geen hoofdbloemen vandaag</p><p class="fh-choice__empty-text">Gebruik het zoekveld of bekijk Selectie van vandaag hieronder.</p></div>'
        anchorGrid.appendChild(empty)
        return
      }
      anchors.forEach(function (a) {
        var media = engine.getAnchorCardMedia(dna, a.id, collectionProducts)
        anchorGrid.appendChild(
          cardButton({
            title: labelOf(a),
            sub:
              media && media.colorIds && media.colorIds.length
                ? media.colorIds.map(colorLabel).join(' · ')
                : '',
            imageUrl: media && media.imageUrl,
            onClick: function () {
              selected.speciesId = a.id
              selected.forceAsAnchor = false
              selected.product = null
              selected.colorId = null
              renderSpeciesColors(a.id)
              go('flower-colors')
            },
          }),
        )
      })
    }

    function runSearch(scope) {
      var input = flow.querySelector('[data-fh-search="' + scope + '"]')
      var results = searchResultsEl(scope)
      if (!results || !input) return
      var q = input.value || ''
      var colorFilter =
        scope === 'color' && selected.colorId ? selected.colorId : null
      var hits = engine.searchLiveProducts(dna, collectionProducts, q, {
        colorId: colorFilter,
      })
      results.innerHTML = ''
      if (!q.trim() || q.trim().length < 2) {
        results.hidden = true
        return
      }
      results.hidden = false
      if (!hits.length) {
        results.innerHTML =
          '<li class="fh-choice__empty-cell"><div class="fh-choice__empty"><p class="fh-choice__empty-title">Niets gevonden</p><p class="fh-choice__empty-text">' +
          (colorFilter
            ? 'Geen match in ' +
              esc(colorLabel(colorFilter)) +
              '. Probeer een andere term of zoek in alle bloemen.'
            : 'Probeer een andere naam of zoek in alle bloemen.') +
          '</p></div></li>'
        return
      }
      hits.slice(0, 24).forEach(function (p) {
        var price =
          typeof p.priceCents === 'number' ? formatMoney(p.priceCents) : ''
        results.appendChild(
          cardButton({
            title: p.speciesLabel || p.displayTitle,
            sub: [p.colorLabel, p.displayTitle].filter(Boolean).join(' · '),
            meta: price ? price + ' · Beschikbaar' : 'Beschikbaar',
            imageUrl: p.imageUrl,
            onClick: function () {
              pickLiveProduct(p)
            },
          }),
        )
      })
    }

    function pickLiveProduct(p) {
      selected.product = p
      selected.speciesId = p.speciesId
      selected.colorId = p.colorId
      selected.forceAsAnchor = !p.canBeCustomerAnchor
      runProposals(p.speciesId, p, !p.canBeCustomerAnchor)
    }

    function renderSpeciesColors(speciesId) {
      var products = engine.getLiveProductsForSpecies(dna, speciesId, collectionProducts)
      var sp = dna.species.find(function (s) {
        return s.id === speciesId
      })
      if (flowerColorLead) {
        flowerColorLead.textContent = 'Kies een beschikbare kleur voor ' + labelOf(sp) + '.'
      }
      speciesColorGrid.innerHTML = ''
      products.forEach(function (p) {
        var price =
          typeof p.priceCents === 'number' ? formatMoney(p.priceCents) : ''
        speciesColorGrid.appendChild(
          cardButton({
            title: p.colorId ? colorLabel(p.colorId) : p.displayTitle,
            sub: p.displayTitle,
            meta: price,
            imageUrl: p.imageUrl,
            onClick: function () {
              selected.colorId = p.colorId
              selected.product = p
              runProposals(speciesId, p, false)
            },
          }),
        )
      })
    }

    function renderLiveColors() {
      var colors = engine.getLiveColors(dna, collectionProducts)
      colorGrid.innerHTML = ''
      if (!colors.length) {
        if (colorEmpty) colorEmpty.hidden = false
        colorGrid.hidden = true
        return
      }
      if (colorEmpty) colorEmpty.hidden = true
      colorGrid.hidden = false
      colors.forEach(function (c) {
        var count = c.productCount || 0
        colorGrid.appendChild(
          cardButton({
            title: c.label || c.id,
            sub: count + (count === 1 ? ' bloem beschikbaar' : ' bloemen beschikbaar'),
            colorId: c.id,
            onClick: function () {
              selected.colorId = c.id
              selected.speciesId = null
              selected.product = null
              clearSearchUi()
              renderColorAnchors(c.id)
              go('color-anchors')
            },
          }),
        )
      })
    }

    function renderColorAnchors(colorId) {
      var products = engine.getLiveProductsForColor
        ? engine.getLiveProductsForColor(dna, colorId, collectionProducts)
        : []
      if (colorAnchorLead) {
        var label = colorLabel(colorId)
        colorAnchorLead.textContent = 'Kies een ' + label.toLowerCase() + ' bloem'
      }
      colorAnchorGrid.innerHTML = ''
      if (!products.length) {
        var empty = document.createElement('li')
        empty.className = 'fh-choice__empty-cell'
        empty.innerHTML =
          '<div class="fh-choice__empty"><p class="fh-choice__empty-title">Geen bloemen in deze kleur</p><p class="fh-choice__empty-text">Kies een andere kleur of zoek in alle bloemen.</p></div>'
        colorAnchorGrid.appendChild(empty)
        return
      }
      products.forEach(function (p) {
        var sp = dna.species.find(function (s) {
          return s.id === p.speciesId
        })
        var price =
          typeof p.priceCents === 'number' ? formatMoney(p.priceCents) : ''
        colorAnchorGrid.appendChild(
          cardButton({
            title: sp ? labelOf(sp) : p.displayTitle,
            sub: p.displayTitle,
            meta: price ? price + ' · Beschikbaar' : 'Beschikbaar',
            imageUrl: p.imageUrl,
            onClick: function () {
              selected.speciesId = p.speciesId
              selected.product = p
              selected.colorId = colorId
              var force = sp ? !sp.selectableAsCustomerAnchor : false
              runProposals(p.speciesId, p, force)
            },
          }),
        )
      })
    }

    function lineVisual(line, focusDominant) {
      var cls =
        'fh-prop__flower' +
        (line.isAnchor && focusDominant ? ' fh-prop__flower--dominant' : '')
      var qty =
        line.quantity != null
          ? '× ' + line.quantity
          : 'Aantal nog te kiezen'
      var price =
        line.lineTotalCents != null ? formatMoney(line.lineTotalCents) : ''
      return (
        '<div class="' +
        cls +
        '">' +
        mediaHtml(line.imageUrl, 'fh-prop__flower-img') +
        '<div class="fh-prop__flower-meta">' +
        '<span class="fh-prop__flower-name">' +
        esc(line.displayName) +
        (line.colorLabel ? ' ' + esc(line.colorLabel) : '') +
        '</span>' +
        '<span class="fh-prop__flower-qty">' +
        esc(qty) +
        '</span>' +
        (price ? '<span class="fh-prop__flower-price">' + esc(price) + '</span>' : '') +
        '</div></div>'
      )
    }

    function renderProposals(batch) {
      enrichedBatch = (batch.proposals || []).map(function (p) {
        return engine.enrichProposalForDisplay(
          dna,
          p,
          collectionProducts,
          selected.product,
        )
      })
      if (resultsTitle) resultsTitle.textContent = 'Kies jouw vaas'
      if (resultsSub) {
        var sp = dna.species.find(function (s) {
          return s.id === selected.speciesId
        })
        resultsSub.textContent = sp
          ? 'Zes voorstellen met ' +
            labelOf(sp) +
            (selected.product && selected.product.colorLabel
              ? ' · ' + selected.product.colorLabel
              : '')
          : 'Zes verschillende samenstellingen'
      }
      proposalsEl.innerHTML = ''
      enrichedBatch.forEach(function (disp, idx) {
        var li = document.createElement('li')
        var isFocus = disp.ruleSet === 'FOCUS'
        li.className =
          'fh-prop' + (isFocus ? ' fh-prop--focus' : '') + ' fh-prop--' + (disp.slot + 1)
        var flowers = (disp.displayLines || [])
          .map(function (l) {
            return lineVisual(l, isFocus)
          })
          .join('')
        var total =
          disp.totalCents != null
            ? '<p class="fh-prop__total">Totaal ' + formatMoney(disp.totalCents) + '</p>'
            : '<p class="fh-prop__total fh-prop__total--soft">Prijs volgt na aantallen</p>'
        li.innerHTML =
          '<div class="fh-prop__head">' +
          (isFocus ? '<span class="fh-prop__badge">Focus Vase</span>' : '') +
          '<h4 class="fh-prop__title">' +
          esc(disp.customerTitle) +
          '</h4>' +
          '<p class="fh-prop__sub">' +
          esc(disp.customerSubtitle) +
          '</p>' +
          (disp.focusHint
            ? '<p class="fh-prop__hint">' + esc(disp.focusHint) + '</p>'
            : '') +
          '</div>' +
          '<div class="fh-prop__flowers">' +
          flowers +
          '</div>' +
          total +
          '<button type="button" class="fh-btn fh-btn--primary fh-prop__cta" data-fh-pick="' +
          idx +
          '">Kies deze vaas</button>'
        proposalsEl.appendChild(li)
      })
      go('results')
    }

    function runProposals(anchorId, product, forceAsAnchor) {
      var batch = engine.generateFlowerProposals({
        dna: dna,
        anchorId: anchorId,
        collectionProducts: collectionProducts,
        availability: availabilityIndex,
        requireLiveAvailability: true,
        forceAsAnchor: !!forceAsAnchor,
      })
      if (!batch.ok) {
        setStatus(
          batch.error === 'no_filler_available'
            ? 'Deze combinatie is vandaag niet beschikbaar. Kies een andere bloem of bekijk de selectie van vandaag.'
            : batch.error === 'anchor_not_available_today'
              ? 'Deze bloem is vandaag niet beschikbaar.'
              : 'Deze bloem kan nu niet als hoofdbloem worden samengesteld. Kies een andere bloem of kleur.',
          true,
        )
        return
      }
      selected.product = product || selected.product
      selected.speciesId = anchorId
      selected.forceAsAnchor = !!forceAsAnchor
      renderProposals(batch)
    }

    function openVase(index) {
      activeDisplay = JSON.parse(JSON.stringify(enrichedBatch[index]))
      if (!activeDisplay) return
      renderVase()
      go('vase')
    }

    function renderVase() {
      if (!vaseLines || !activeDisplay) return
      if (vaseError) {
        vaseError.hidden = true
        vaseError.textContent = ''
      }
      vaseLines.innerHTML = ''
      activeDisplay.displayLines.forEach(function (line, i) {
        var row = document.createElement('div')
        row.className = 'fh-vase__row'
        var canEdit = line.needsQuantity || line.isAnchor || true
        var max = 20
        var sp = dna.species.find(function (s) {
          return s.id === line.speciesId
        })
        if (
          activeDisplay.ruleSet === 'STANDARD' &&
          sp &&
          typeof sp.standard?.maxStems === 'number'
        ) {
          max = sp.standard.maxStems
        }
        var qty = line.quantity == null ? 1 : line.quantity
        if (line.needsQuantity) line.quantity = qty
        row.innerHTML =
          mediaHtml(line.imageUrl, 'fh-vase__img') +
          '<div class="fh-vase__info">' +
          '<span class="fh-vase__name">' +
          esc(line.displayName) +
          (line.colorLabel ? ' · ' + esc(line.colorLabel) : '') +
          '</span>' +
          '<span class="fh-vase__unit">' +
          (line.unitPriceCents != null
            ? formatMoney(line.unitPriceCents) + ' / steel'
            : '') +
          '</span>' +
          '</div>' +
          '<div class="fh-vase__qty">' +
          '<button type="button" class="fh-vase__btn" data-fh-qty-dec="' +
          i +
          '" aria-label="Minder">−</button>' +
          '<span class="fh-vase__qty-val" data-fh-qty-val="' +
          i +
          '">' +
          qty +
          '</span>' +
          '<button type="button" class="fh-vase__btn" data-fh-qty-inc="' +
          i +
          '" data-fh-qty-max="' +
          max +
          '" aria-label="Meer">+</button>' +
          '</div>' +
          '<div class="fh-vase__line-total" data-fh-line-total="' +
          i +
          '">' +
          (line.unitPriceCents != null ? formatMoney(line.unitPriceCents * qty) : '') +
          '</div>'
        vaseLines.appendChild(row)
        line.quantity = qty
        line.needsQuantity = false
        line.lineTotalCents =
          line.unitPriceCents != null ? line.unitPriceCents * qty : null
        line.purchasable = !!(line.shopifyVariantId && qty > 0)
      })
      recalculateVase()
    }

    function recalculateVase() {
      if (!activeDisplay) return
      var all = activeDisplay.displayLines.every(function (l) {
        return l.quantity != null && l.quantity > 0 && l.shopifyVariantId
      })
      var priced = activeDisplay.displayLines.every(function (l) {
        return l.lineTotalCents != null
      })
      activeDisplay.totalCents = priced
        ? activeDisplay.displayLines.reduce(function (s, l) {
            return s + l.lineTotalCents
          }, 0)
        : null
      activeDisplay.needsQuantity = false
      activeDisplay.cartReady = all
      if (vaseTotal) {
        vaseTotal.textContent =
          activeDisplay.totalCents != null
            ? 'Totaal ' + formatMoney(activeDisplay.totalCents)
            : 'Totaal volgt'
      }
    }

    function changeQty(index, delta, max) {
      var line = activeDisplay.displayLines[index]
      if (!line) return
      var next = (line.quantity || 1) + delta
      if (next < 1) next = 1
      if (typeof max === 'number' && next > max) next = max
      // STANDARD anchor caps
      var sp = dna.species.find(function (s) {
        return s.id === line.speciesId
      })
      if (
        activeDisplay.ruleSet === 'STANDARD' &&
        sp &&
        typeof sp.standard?.maxStems === 'number' &&
        next > sp.standard.maxStems
      ) {
        next = sp.standard.maxStems
      }
      line.quantity = next
      line.lineTotalCents =
        line.unitPriceCents != null ? line.unitPriceCents * next : null
      var val = vaseLines.querySelector('[data-fh-qty-val="' + index + '"]')
      if (val) val.textContent = String(next)
      var tot = vaseLines.querySelector('[data-fh-line-total="' + index + '"]')
      if (tot && line.lineTotalCents != null) {
        tot.textContent = formatMoney(line.lineTotalCents)
      }
      recalculateVase()
    }

    function addToCart() {
      if (!activeDisplay) return
      // refresh cartReady
      activeDisplay.cartReady = activeDisplay.displayLines.every(function (l) {
        return l.shopifyVariantId && l.quantity > 0
      })
      var built = engine.buildCartItemsFromDisplay(activeDisplay)
      if (!built.ok) {
        if (vaseError) {
          vaseError.hidden = false
          vaseError.textContent =
            'Nog niet alles is compleet. Controleer de aantallen en probeer opnieuw.'
        }
        return
      }
      var btn = flow.querySelector('[data-fh-add-cart]')
      if (btn) {
        btn.disabled = true
        btn.textContent = 'Bezig…'
      }
      fetch(config.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: built.items }),
        credentials: 'same-origin',
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().catch(function () {
              return {}
            }).then(function (body) {
              throw new Error(body.description || body.message || 'Cart fout')
            })
          }
          return r.json()
        })
        .then(function () {
          if (btn) {
            btn.disabled = false
            btn.textContent = 'Toevoegen aan winkelmand'
          }
          prepareAiPayload()
          go('cart-success')
        })
        .catch(function (err) {
          if (btn) {
            btn.disabled = false
            btn.textContent = 'Toevoegen aan winkelmand'
          }
          if (vaseError) {
            vaseError.hidden = false
            vaseError.textContent =
              'Toevoegen mislukt. Niets is half toegevoegd — probeer opnieuw. ' +
              (err && err.message ? '' : '')
          }
        })
    }

    function prepareAiPayload() {
      if (!aiBlock) return
      var payload = {
        type: 'flowerheart_ai_preview_request',
        ruleSet: activeDisplay && activeDisplay.ruleSet,
        anchorId: selected.speciesId,
        colorId: selected.colorId,
        lines: (activeDisplay && activeDisplay.displayLines) || [],
        selectedProduct: selected.product,
      }
      aiBlock.setAttribute('data-fh-ai-payload', JSON.stringify(payload))
      if (aiEnabled) {
        aiBlock.hidden = false
      } else {
        aiBlock.hidden = true
      }
    }

    flow.addEventListener('click', function (e) {
      var t = e.target
      if (t.closest('[data-fh-back]')) {
        goBack()
        return
      }
      if (t.closest('[data-fh-reset]')) {
        resetAll()
        return
      }
      if (t.closest('[data-fh-add-cart]')) {
        addToCart()
        return
      }
      if (t.closest('[data-fh-other-proposal]')) {
        goBack()
        return
      }
      var pick = t.closest('[data-fh-pick]')
      if (pick) {
        openVase(Number(pick.getAttribute('data-fh-pick')))
        return
      }
      var dec = t.closest('[data-fh-qty-dec]')
      if (dec) {
        changeQty(Number(dec.getAttribute('data-fh-qty-dec')), -1)
        return
      }
      var inc = t.closest('[data-fh-qty-inc]')
      if (inc) {
        changeQty(
          Number(inc.getAttribute('data-fh-qty-inc')),
          1,
          Number(inc.getAttribute('data-fh-qty-max')),
        )
        return
      }
      var modeBtn = t.closest('[data-fh-mode]')
      if (modeBtn) {
        var mode = modeBtn.getAttribute('data-fh-mode')
        selected.mode = mode
        history = ['modes']
        if (mode === 'flower') {
          clearSearchUi()
          renderFlowerAnchors()
          go('flower-anchors')
        } else {
          clearSearchUi()
          renderLiveColors()
          go('color-list')
        }
      }
    })

    searchInputs.forEach(function (input) {
      var searchTimer = null
      var scope = input.getAttribute('data-fh-search')
      input.addEventListener('input', function () {
        clearTimeout(searchTimer)
        searchTimer = setTimeout(function () {
          runSearch(scope)
        }, 160)
      })
    })

    function boot() {
      engine = global.FhRecipeEngine
      if (!engine) {
        setStatus('De samensteller kon niet laden. Vernieuw de pagina.', true)
        return
      }
      try {
        collectionProducts = collectionNode
          ? JSON.parse(collectionNode.textContent || '[]')
          : []
      } catch (err) {
        collectionProducts = []
      }
      // Attach mapping image/price fallbacks
      collectionProducts = collectionProducts.map(function (p) {
        return Object.assign({}, p, {
          priceCents:
            typeof p.priceCents === 'number'
              ? p.priceCents
              : typeof p.price === 'number'
                ? p.price
                : null,
        })
      })

      fetch(config.dnaUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('dna')
          return r.json()
        })
        .then(function (raw) {
          dna = engine.loadDnaFromPublic(raw)
          aiEnabled = !!(raw.features && raw.features.aiPreviewEnabled)
          availabilityIndex = engine.buildAvailabilityFromCollection(
            dna,
            collectionProducts,
          )
          // Enrich live products with mapping image/price when collection omits
          var live = engine.getLiveMappedProducts(dna, collectionProducts)
          live.forEach(function (lp) {
            var row = collectionProducts.find(function (c) {
              return String(c.handle).toLowerCase() === String(lp.shopifyProductHandle).toLowerCase()
            })
            if (row && !row.imageUrl && lp.imageUrl) row.imageUrl = lp.imageUrl
            if (row && row.priceCents == null && lp.priceCents != null) {
              row.priceCents = lp.priceCents
            }
          })
          showStep('modes')
          if (!collectionProducts.length) {
            setStatus(
              'Koppel in Theme Editor de collectie “Selectie van vandaag” om te starten.',
              true,
            )
          }
        })
        .catch(function () {
          setStatus('Gegevens konden niet worden geladen. Vernieuw de pagina.', true)
        })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot)
    } else {
      boot()
    }
  }

  global.FhChoiceUI = { init: initChoiceFlow, formatMoney: formatMoney }
})(typeof window !== 'undefined' ? window : globalThis)
